import { render, staticRenderFns } from "./OrderPrintLabel.vue?vue&type=template&id=2bb1ae2e&scoped=true&"
import script from "./OrderPrintLabel.vue?vue&type=script&lang=js&"
export * from "./OrderPrintLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1ae2e",
  null
  
)

export default component.exports